import { Button } from 'antd';
import { getPropsFromUrl } from 'components/hoc/index';
import { Panel } from 'components/ui/index';
import React from 'react';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { compose } from 'redux';
import { isValidClientTypes } from 'utils/propChecks';
import { SummaryPreviewTable } from '../components/index';

const propTypes = {
  intl: intlShape.isRequired,
  objectType: isValidClientTypes
};

const ReportPreview = ({ intl, objectType, dynamicReportId }) => {
  return (
    <Panel
      panelTitle={
        <FormattedMessage
          id="page.ReportPreview.title"
          values={{
            type: intl.formatMessage({ id: `global.properNouns.${objectType}` })
          }}
        />
      }
      actionsRight={
        <Link to={`/reports/${dynamicReportId}/real-time/generate`}>
          <Button
            className="report-theme-btn"
            size="small"
            disabled={dynamicReportId === 'new'}
          >
            <FormattedMessage id="page.ReportPreview.generate" />
          </Button>
        </Link>
      }
      panelClasses="report-theme-panel"
    >
      <SummaryPreviewTable />
    </Panel>
  );
};

const mapStateToProps = ({ global }, ownProps) => {
  const paths = ownProps.history.location.pathname.split('/');
  const dynamicReportId = paths[paths.length - 1]
    ? paths[paths.length - 1]
    : 'new';
  return {
    dynamicReportId,
    lang: global.language
  };
};
ReportPreview.propTypes = propTypes;
const enhancers = compose(
  getPropsFromUrl(['objectType', 'reportId']),
  injectIntl,
  connect(mapStateToProps)
);
export default enhancers(ReportPreview);



// WEBPACK FOOTER //
// ./src/views/ReportPreview/container/index.jsx